/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyPublicType: core.serialization.Schema<serializers.KeyPublicType.Raw, Truvity.KeyPublicType> =
    core.serialization.enum_(['ED25519', 'P256', 'P384']);

export declare namespace KeyPublicType {
    export type Raw = 'ED25519' | 'P256' | 'P384';
}
